import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const formatDate = (date, format = "YYYY.MM.DD") => {
  if (dayjs(date, format).format(format) === dayjs("0001-01-01", format).format(format) || !date) {
    return "-";
  }
  return dayjs(date, format).format(format);
};

export const formatDateTimeUtc = (date, format = "YYYY.MM.DD HH:mm:ss") => {
  if (dayjs(date, format).format(format) === dayjs("0001-01-01:00:00:00", format).format(format) || !date) {
    return "-";
  }
  return date ? dayjs(date, format).add(8, "hour").format(format) : date;
};

export const formatDateTime = (date, format = "YYYY.MM.DD HH:mm:ss") => {
  if (dayjs(date, format).format(format) === dayjs("0001-01-01:00:00:00", format).format(format) || !date) {
    return "-";
  }
  return date ? dayjs(date, format).add(8, "hour").format(format) : date;
};

export const formatCurrency = (amount) => {
  if (amount) {
    const am = Number(amount);
    if (isNaN(am)) {
      return amount;
    }

    return Number(amount)
      .toFixed(2)
      .toLocaleString()
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};

export const formatObjToTree = (arr) => {
  const nest = (items, id = "0", link = "filter") =>
    items
      .filter((item) => item[link] === id)
      .map((item) => ({
        value: item.val,
        label: item.txt,
        ...(nest(items, item.val).length > 0 && {
          children: nest(items, item.val),
        }),
      }));
  return nest(arr);
};
